import classNames from 'classnames';
import * as React from 'react';
import AnonymousHeader from './AnonymousHeader';
import Footer from './footer/Footer';
import { Logo } from '../../models/be/Branding';
import { hasValue, hasVettingLogo } from '../../lib/utils';
import './AnonymousLayout.less';

const AnonymousLayout = (props: Props) => {
	if (!props.children) throw new Error('Layout should always have children, a Loader at least');

	return (
		<section className="anonymousLayout">
			<AnonymousHeader
				title={props.title}
				stacked={props.stackedHeader}
				renderHeading={props.renderHeading}
				logo={props.logo}
			/>
			<section className={classNames('content', props.className)}>{props.children}</section>
			<Footer showPoweredBy={hasValue(props.logo) && !hasVettingLogo(props.logo)} />
		</section>
	);
};

interface Props {
	title: string;
	children: React.ReactNode;
	renderHeading?: boolean;
	className?: string;
	stackedHeader?: boolean;
	logo?: Logo;
}

AnonymousLayout.defaultProps = {
	renderHeading: false,
	className: null,
	stackedHeader: false,
	logo: null
};

export default AnonymousLayout;
